import ApiClient from './ApiClient';

class QuepasaAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getQRCode(inboxId) {
    return axios.get(`${this.url}/${inboxId}/quepasa/qr_code`);
  }

  getStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/quepasa/status`);
  }

  disconnect(inboxId) {
    return axios.post(`${this.url}/${inboxId}/quepasa/disconnect`);
  }

  updateSettings(inboxId, data) {
    return axios.patch(`${this.url}/${inboxId}/quepasa/update_settings`, {
      quepasa: data,
    });
  }

  setupWebhooks(inboxId) {
    return axios.post(`${this.url}/${inboxId}/quepasa/setup_webhooks`);
  }

  syncContacts(inboxId) {
    return axios.post(`${this.url}/${inboxId}/quepasa/sync_contacts`);
  }
}

export default new QuepasaAPI();
